import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { setAddressVerification } from '@r1-frontend/entities/ContactAddress/actions/checkAddress';
import { fillAddressAction } from '@r1-frontend/entities/ContactAddress/actions/fillAddress';

import { ADDRESS_PARAM_NAME, getVerifiedAddress } from '~/src/features/full-buy/consts';
import { getSessionStorageByKey } from '~/src/helpers/storage';

/**
 * Получает верифицированный адрес из хранилища и записывает в стор
 */
export const useStorageAddress = () => {
    const dispatch = useDispatch();

    const defaultAddress = useMemo(() => {
        const resp = getSessionStorageByKey(ADDRESS_PARAM_NAME);
        return getVerifiedAddress(resp);
    }, []);

    useEffect(() => {
        if (defaultAddress && defaultAddress.address) {
            dispatch(setAddressVerification(defaultAddress));
            dispatch(fillAddressAction(defaultAddress.address));
            sessionStorage.removeItem(ADDRESS_PARAM_NAME);
        }
    }, []);
};
